import { cartConstants } from "../_constants";
import {
  getCartItems,
  addCartItem,
  updateCartService,
  clearCartService,
  makePaymentService,
  verifyCheckoutService,
  getWishlist,
  handleDeleteWishlist,
  handlePostWishlist,
  removeCartService,
} from "../_services/cart.service";
import { courseActions } from "../_actions/course.actions.js";
export const fetchCart = () => (dispatch) => {
  dispatch({ type: cartConstants.FETCH_CART_START });
  getCartItems()
    .then((data) => {
      if (data) {
        dispatch({
          type: cartConstants.FETCH_CART_END,
          payload: [...data.Bundles, ...data.Courses],
        });
      }
    })
    .catch((error) => console.log(error));
};

export const updateCart = (items, cartItem, countryCode) => (dispatch) => {
  if (items.length > 1) {
    updateCartService(cartItem, countryCode)
      .then((data) => {
        if (!data.error) {
          dispatch({ type: cartConstants.FETCH_CART_END, payload: data.data });
        }
      })
      .catch((error) => console.log(error));
  } else {
    dispatch(clearCart());
  }
};

export const addCourse = (cartItem) => (dispatch) => ({
  type: cartConstants.ADD_TO_CART,
  payload: cartItem,
});

export const addToCart =
  (cartItem, coupon, { longitude, latitude, country_code } = {}, bundle) =>
  (dispatch) => {
    dispatch({ type: cartConstants.ADD_TO_CART_PROCESSING, payload: cartItem });
    addCartItem(
      cartItem,
      coupon,
      longitude,
      latitude,
      country_code,
      bundle
    ).then((data) => {
      if (!data.error) {
        dispatch({ type: cartConstants.ADD_TO_CART_SUCCESS });
        dispatch(fetchCart());
      } else {
        if (data.errorCode === 7002) {
          dispatch({
            type: cartConstants.ADD_TO_CART_FAILED,
            payload: "Item Already Purchased",
          });
        } else {
          dispatch({
            type: cartConstants.ADD_TO_CART_FAILED,
            payload: "Sorry! Something Went Wrong!",
          });
        }
      }
    });
  };

export const removeCartItem = (cartItem) => (dispatch) => {
  removeCartService(cartItem)
    .then((data) => {
      if (!data.error) {
        dispatch({
          type: cartConstants.REMOVE_CART_ITEM,
        });
        dispatch(fetchCart());
      }
    })
    .catch((error) => console.log(error));
};

export const clearCart = () => (dispatch) => {
  clearCartService()
    .then((data) => {
      if (data) {
        localStorage.removeItem("ck_session");
        dispatch(fetchCart());
      }
    })
    .catch((error) => console.log(error));
};

export const makePayment = (items) => (dispatch) => {
  makePaymentService(items).then((data) => (window.location.href = data.url));
};

// export const chargeCard = (token) => (dispatch) => {
//   chargeCardService(token)
//   .then((data) => {
//       if (data) {
//         dispatch({ type: cartConstants.CHARGE_CARD_SUCCESS, payload: data });
//       }
//     })
//     .catch((error) => console.log(error));;
// };

export const verifyCheckoutSession =
  (sessionId, countryCode, enterpriseStatus) => (dispatch) => {
    dispatch({ type: cartConstants.CHECKOUT_PROCESSING });
    verifyCheckoutService(sessionId, countryCode, enterpriseStatus).then(
      (data) => {
        if (!data.error) {
          dispatch(clearCart());
          dispatch({ type: cartConstants.CHECKOUT_SUCCESS, payload: data });
          localStorage.removeItem("ck_session");
        } else {
          dispatch({ type: cartConstants.CHECKOUT_FAILURE, payload: data });
        }
      }
    );
  };

export const verifyStripeCheckout = (data) => (dispatch) => {
  dispatch(fetchCart());
  dispatch({ type: cartConstants.CHECKOUT_SUCCESS, payload: data });
};

export const getStudentWishlist = () => (dispatch) => {
  dispatch({ type: cartConstants.FETCH_WISHLIST_START });
  getWishlist()
    .then((data) => {
      if (data) {
        dispatch({ type: cartConstants.FETCH_WISHLIST_END, payload: data });
      }
    })
    .catch((error) => console.log(error));
};

export const deleteWishlist = (courseId) => (dispatch) => {
  dispatch({ type: cartConstants.FETCH_WISHLIST_START });
  handleDeleteWishlist(courseId)
    .then((data) => {
      if (data) {
        dispatch(getStudentWishlist());
        dispatch({ type: cartConstants.FETCH_WISHLIST_END, payload: data });
        dispatch(courseActions.fetchCourses(1, null, null, null));
      }
    })
    .catch((error) => console.log(error));
};

export const addWishlist = (courseId) => (dispatch) => {
  dispatch({ type: cartConstants.FETCH_WISHLIST_START });
  handlePostWishlist(courseId)
    .then((data) => {
      if (data) {
        dispatch({ type: cartConstants.FETCH_WISHLIST_END, payload: data });
        dispatch(courseActions.fetchCourses(1, null, null, null));
      }
    })
    .catch((error) => console.log(error));
};
